if (!customElements.get('product-slider-thumbnails')) {
  /**
   *  @class
   *  @function ProductSliderThumbnails
   *
   *  FIX 2026-09-24 (miniaturas desfasadas):
   *  - Cada miniatura abre SU foto por ID (Thumb-… -> Slide-…), no por posición.
   *  - El carrusel se re-sincroniza cuando el tema oculta/muestra fotos de otro color,
   *    para que no queden "fotos fantasma" ocultas ocupando lugares.
   *  - Un solo listener de clic (delegado) para evitar que se acumulen en cada reInit.
   */
  class ProductSliderThumbnails extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
      // Keep Flickity cells in sync with the visible color group
      this.observeSlides();
      // Single delegated click handler for thumbnails
      this.bindThumbnailClicks();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    observeSlides() {
      if (!this.hide_variants || typeof MutationObserver === 'undefined') return;
      this.syncTimer = null;
      const observer = new MutationObserver(() => {
        clearTimeout(this.syncTimer);
        this.syncTimer = setTimeout(() => this.syncCells(), 60);
      });
      this.querySelectorAll('.product-images__slide').forEach((slide) => {
        observer.observe(slide, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }
    // Rebuild Flickity only if its cells no longer match the visible (.is-active) slides
    syncCells() {
      if (!this.flkty) return;
      const active = Array.from(this.querySelectorAll('.product-images__slide.is-active'));
      const cells = this.flkty.cells.map((cell) => cell.element);
      const inSync = active.length === cells.length && cells.every((el) => el.classList.contains('is-active'));
      if (inSync) return;

      const current = this.flkty.selectedElement;
      this.reInit();
      if (current && current.classList.contains('is-active')) {
        const i = this.flkty.cells.findIndex((cell) => cell.element === current);
        if (i > -1) this.flkty.select(i, false, true);
      }
    }
    bindThumbnailClicks() {
      if (!this.thumbnail_container || this.thumbnail_container.dataset.clickBound === 'true') return;
      this.thumbnail_container.dataset.clickBound = 'true';
      this.thumbnail_container.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('.product-thumbnail');
        if (thumbnail && this.thumbnail_container.contains(thumbnail)) {
          this.thumbnailClick(thumbnail);
        }
      });
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_cell = this.flkty.cells[_this.selectedIndex],
          previous_slide = previous_cell ? previous_cell.element : null,
          previous_media = previous_slide ? previous_slide.querySelector('.product-single__media') : null,
          current_cell = this.flkty.cells[index],
          active_thumb = null;

        // Match the thumbnail to the slide by media ID (not by position)
        if (current_cell && current_cell.element.id) {
          active_thumb = document.getElementById(current_cell.element.id.replace(/^Slide-/, 'Thumb-'));
        }
        if (!active_thumb) {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active'));
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];
        }

        if (active_thumb) {
          this.thumbnails.forEach((item, i) => {
            item.classList.remove('is-initial-selected');
          });
          active_thumb.classList.add('is-initial-selected');

          requestAnimationFrame(() => {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
              top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
              behavior: 'smooth'
            });
          });
        }

        // Stop previous video
        if (!previous_media) return;
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });

    }
    thumbnailClick(thumbnail) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');

      // Make sure no hidden slides are still counted as cells
      this.syncCells();

      const slide = thumbnail.id ? document.getElementById(thumbnail.id.replace(/^Thumb-/, 'Slide-')) : null;
      if (!slide) return;
      const i = this.flkty.cells.findIndex((cell) => cell.element === slide);
      if (i > -1) {
        this.flkty.select(i);
      }
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider-thumbnails', ProductSliderThumbnails);
}
